export default __webpack_public_path__ + "static/media/paymentCompleted.e0d5eb04.svg";